<script>
  import { checkbox } from 'vue-strap';
  import { datepicker } from 'vue-strap';
  import Radio from '~componentes/Radio.vue';

  export default {
    components: { checkbox, Radio, datepicker },
    props: {
      solicitacao: Object,
      edicao: Boolean
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
      }
    },
    computed: {
      resumoContador: function() {
        let quantidadeCaracteres = this.solicitacao.resumo ? 
            this.solicitacao.resumo.length : 0;

        return 300 - quantidadeCaracteres;
      },
      labelDescricao() {
        if (parseInt(this.solicitacao.tipoSolicitacao) == 1) {
          return 'Nome do curso';
        }
        if (parseInt(this.solicitacao.tipoSolicitacao) == 2) {
          return 'Nome do evento';
        }
        return 'Descrição';
      },
    },
    methods: {
      preencherDadosContato() {
        let usuario = this.$storage.usuario();

        this.$set(this.solicitacao, 'nomeSolicitante', usuario.nome);
        this.$set(this.solicitacao, 'emailSolicitante', usuario.email);
        this.$set(this.solicitacao, 'telefoneSolicitante', usuario.telefone.substring(0, 20));
      },
      validarDadosSolicitacao() {
        return this.$validator.validateAll();
      },
    },
    mounted() {
    },
  }
</script>

<template>
  <div>
    <div class="row">
      <div class="col-sm-10">
        <div class="form-group required" :class="{'has-error': errors.has('descricao')}">
          <label class="control-label" for="documento">{{ labelDescricao }}</label>

          <input type="text"
                 class="form-control"
                 id="descricao"
                 v-model="solicitacao.descricao"
                 data-vv-as="Descrição"
                 data-vv-name="descricao"
                 maxlength="200"
                 disabled
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('descricao')">{{ errors.first('descricao') }}</p>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group required" :class="{'has-error': errors.has('tipo')}">
          <label class="control-label block">Tipo solicitação</label>

          <radio v-model="solicitacao.tipoSolicitacao"
                 selected-value="1"
                 type="success"
                 :inline="true"
                 disabled
                 class="margin-right-10">
            Curso
          </radio>
          <radio v-model="solicitacao.tipoSolicitacao"
                 selected-value="2"
                 type="success"
                 :inline="true"
                 disabled
                 class="margin-right-10">
            Evento
          </radio>
          <radio v-model="solicitacao.tipoSolicitacao"
                 selected-value="3"
                 type="success"
                 disabled
                 v-if="false"
                 :inline="true">
            Serviço
          </radio>
          <radio v-model="solicitacao.tipoSolicitacao"
                 selected-value="4"
                 type="success"
                 disabled
                 :inline="true">
            Doação
          </radio>

          <p class="text-danger" v-show="errors.has('tipo')">{{ errors.first('tipo') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="form-group required" :class="{'has-error': errors.has('resumo')}">
          <label class="control-label" for="resumo">
            Resumo ({{ resumoContador }})
          </label>

          <textarea class="form-control"
                    id="resumo"
                    v-model="solicitacao.resumo"
                    data-vv-rules="required"
                    data-vv-as="resumo"
                    data-vv-name="resumo"
                    v-validate
                    maxlength="300">
          </textarea>

          <p class="text-danger" v-show="errors.has('resumo')">{{ errors.first('resumo') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group" :class="{'has-error': errors.has('instituicao')}">
          <label class="control-label" for="instituicao">
            Instituição Responsável
          </label>

          <input type="text"
                 class="form-control"
                 id="instituicao"
                 v-model="solicitacao.instituicao"
                 maxlength="150"
                 data-vv-name="instituicao"
                 data-vv-as="instituição responsável">

          <p class="text-danger" v-show="errors.has('instituicao')">{{ errors.first('instituicao') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group" :class="{'has-error': errors.has('unidade')}">
          <label class="control-label" for="unidade">
            Unidade
          </label>

          <input type="text"
                 class="form-control"
                 id="unidade"
                 v-model="solicitacao.unidade"
                 maxlength="80"
                 data-vv-name="unidade"
                 data-vv-as="unidade">

          <p class="text-danger" v-show="errors.has('unidade')">{{ errors.first('unidade') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group" :class="{'has-error': errors.has('departamento')}">
          <label class="control-label" for="departamento">
            Departamento
          </label>

          <input type="text"
                 class="form-control"
                 id="departamento"
                 v-model="solicitacao.departamento"
                 maxlength="80"
                 data-vv-name="departamento"
                 data-vv-as="departamento">

          <p class="text-danger" v-show="errors.has('departamento')">{{ errors.first('departamento') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="((this.solicitacao.tipoSolicitacao == 1) || (this.solicitacao.tipoSolicitacao == 2))">
      <div class="form-group col-xs-2" :class="{'has-error': errors.has('alunosMaximo')}">
        <label class="control-label" for="alunosMaximo">Nº participantes máximo</label>

        <input type="text"
               class="form-control text-right"
               id="alunosMaximo"
               v-mascara="'numero'"
               v-model="solicitacao.solicitacaoCursoEventos[0].alunosMaximo"
               data-vv-name="alunosMaximo"
               data-vv-as="participantes máximo">

        <p class="text-danger" v-show="errors.has('alunosMaximo')">{{ errors.first('alunosMaximo') }}</p>
      </div>

      <div class="form-group col-xs-2" :class="{'has-error': errors.has('alunosMinimo')}">
        <label class="control-label" for="alunosMinimo">Nº participantes mínimo</label>

        <input type="text"
               class="form-control text-right"
               id="alunosMinimo"
               v-mascara="'numero'"
               v-model="solicitacao.solicitacaoCursoEventos[0].alunosMinimo"
               data-vv-name="alunosMinimo"
               data-vv-as="participantes mínimo">

        <p class="text-danger" v-show="errors.has('alunosMinimo')">{{ errors.first('alunosMinimo') }}</p>
      </div>

      <div class="col-lg-2">
        <div class="form-group">
          <label class="control-label">Data início</label>

          <datepicker id="dataInicio"
                      v-model="solicitacao.solicitacaoCursoEventos[0].dataInicio"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataInicio"
                      data-vv-as="Data início"
                      v-mascara="'data-mask'"
                      v-validate="'date_format:DD/MM/YYYY'">
          </datepicker>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group">
          <label class="control-label">Data fim</label>

          <datepicker id="dataFim"
                      v-model="solicitacao.solicitacaoCursoEventos[0].dataFim"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataFim"
                      data-vv-as="Data fim"
                      v-mascara="'data-mask'"
                      v-validate="'date_format:DD/MM/YYYY'">
          </datepicker>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('dataInicioInscricao')}">
          <label class="control-label">Início inscrição</label>

          <datepicker id="dataInicioInscricao"
                      v-model="solicitacao.solicitacaoCursoEventos[0].dataInicioInscricao"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataInicioInscricao"
                      data-vv-as="Início inscrição"
                      v-mascara="'data-mask'"
                      v-validate="'required|date_format:DD/MM/YYYY'">
          </datepicker>

          <p class="text-danger" v-show="errors.has('dataInicioInscricao')">{{ errors.first('dataInicioInscricao') }}</p>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('dataLimiteInscricao')}">
          <label class="control-label">Limite inscrição</label>

          <datepicker id="dataLimiteInscricao"
                      v-model="solicitacao.solicitacaoCursoEventos[0].dataLimiteInscricao"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataLimiteInscricao"
                      data-vv-as="Limite inscrição"
                      v-mascara="'data-mask'"
                      v-validate="'required|date_format:DD/MM/YYYY'">
          </datepicker>

          <p class="text-danger" v-show="errors.has('dataLimiteInscricao')">{{ errors.first('dataLimiteInscricao') }}</p>
        </div>
      </div>
    </div>

    <div class="row" v-if="((this.solicitacao.tipoSolicitacao == 1) || (this.solicitacao.tipoSolicitacao == 2))">
      <div class="col-lg-2">
        <div class="form-group">
          <label class="control-label">Venc. 1ª parcela</label>

          <datepicker id="dataVencimentoParcela"
                      v-model="solicitacao.solicitacaoCursoEventos[0].dataVencimentoParcela"
                      format="dd/MM/yyyy"
                      placeholder="  /  /     "
                      lang="pt-BR"
                      data-vv-name="dataVencimentoParcela"
                      data-vv-as="Venc. 1ª parcela"
                      v-mascara="'data-mask'"
                      v-validate="'date_format:DD/MM/YYYY'">
          </datepicker>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group">
          <label class="control-label" for="parcelas">Nº parcelas</label>

          <input type="text"
                 class="form-control text-right"
                 id="parcelas"
                 v-mascara="'numero'"
                 v-model="solicitacao.solicitacaoCursoEventos[0].parcelas">
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group">
          <label class="control-label" for="valorParcela">Valor parcela</label>

          <input type="text"
                 class="form-control text-right"
                 id="valorParcela"
                 v-mascara="'moeda'"
                 v-model="solicitacao.solicitacaoCursoEventos[0].valorParcela">
        </div>
      </div>
    </div>

    <div class="row" v-if="(this.solicitacao.tipoSolicitacao == 4)">
      <div class="form-group col-xs-2" :class="{'has-error': errors.has('valorMinimoDoacao')}">
        <label class="control-label" for="valorMinimoDoacao">Valor mínimo</label>

        <input type="text"
               class="form-control text-right"
               id="valorMinimoDoacao"
               v-mascara="'moeda'"
               v-model="solicitacao.solicitacaoDoacao[0].valorMinimo"
               data-vv-name="valorMinimoDoacao"
               data-vv-as="valor mínimo">

        <p class="text-danger" v-show="errors.has('valorMinimoDoacao')">{{ errors.first('valorMinimoDoacao') }}</p>
      </div>

      <div class="form-group col-xs-2" :class="{'has-error': errors.has('valorMaximoDoacao')}">
        <label class="control-label" for="valorMaximoDoacao">Valor máximo</label>

        <input type="text"
               class="form-control text-right"
               id="valorMaximoDoacao"
               v-mascara="'moeda'"
               v-model="solicitacao.solicitacaoDoacao[0].valorMaximo"
               data-vv-name="valorMaximoDoacao"
               data-vv-as="valor máximo">

        <p class="text-danger" v-show="errors.has('valorMaximoDoacao')">{{ errors.first('valorMaximoDoacao') }}</p>
      </div>

      <div class="form-group col-xs-2" :class="{'has-error': errors.has('valorPadrao1')}">
        <label class="control-label" for="valorPadrao1">Valor padrão 1</label>

        <input type="text"
               class="form-control text-right"
               id="valorPadrao1"
               v-mascara="'moeda'"
               v-model="solicitacao.solicitacaoDoacao[0].valorPadrao1"
               data-vv-name="valorPadrao1"
               data-vv-as="valor padrão 1">

        <p class="text-danger" v-show="errors.has('valorPadrao1')">{{ errors.first('valorPadrao1') }}</p>
      </div>

      <div class="form-group col-xs-2" :class="{'has-error': errors.has('valorPadrao2')}">
        <label class="control-label" for="valorPadrao1">Valor padrão 2</label>

        <input type="text"
               class="form-control text-right"
               id="valorPadrao2"
               v-mascara="'moeda'"
               v-model="solicitacao.solicitacaoDoacao[0].valorPadrao2"
               data-vv-name="valorPadrao2"
               data-vv-as="valor padrão 2">

        <p class="text-danger" v-show="errors.has('valorPadrao2')">{{ errors.first('valorPadrao2') }}</p>
      </div>

      <div class="form-group col-xs-2" :class="{'has-error': errors.has('valorPadrao3')}">
        <label class="control-label" for="valorPadrao3">Valor padrão 3</label>

        <input type="text"
               class="form-control text-right"
               id="valorPadrao3"
               v-mascara="'moeda'"
               v-model="solicitacao.solicitacaoDoacao[0].valorPadrao3"
               data-vv-name="valorPadrao3"
               data-vv-as="valor padrão 3">

        <p class="text-danger" v-show="errors.has('valorPadrao3')">{{ errors.first('valorPadrao3') }}</p>
      </div>

      <div class="form-group col-xs-2" :class="{'has-error': errors.has('valorPadrao4')}">
        <label class="control-label" for="valorPadrao4">Valor padrão 4</label>

        <input type="text"
               class="form-control text-right"
               id="valorPadrao4"
               v-mascara="'moeda'"
               v-model="solicitacao.solicitacaoDoacao[0].valorPadrao4"
               data-vv-name="valorPadrao4"
               data-vv-as="valor padrão 4">

        <p class="text-danger" v-show="errors.has('valorPadrao4')">{{ errors.first('valorPadrao4') }}</p>
      </div>
    </div>

    <p>
      <b>
        Informe os dados da pessoa que devemos contatar, caso haja dúvidas ao
        processarmos essa solicitação, ou marque o campo abaixo.
      </b>
    </p>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <button type="button" class="btn btn-xs btn-success" @click="preencherDadosContato">
            <i class="fa fa-user-circle"></i> Clique aqui para preencher com os seus dados
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-5">
        <div class="form-group" :class="{'has-error': errors.has('nomeSolicitante')}">
          <label class="control-label" for="nome-solicitante">Nome</label>

          <input type="text"
                 class="form-control"
                 id="nome-solicitante"
                 data-vv-name="nomeSolicitante"
                 v-model="solicitacao.nomeSolicitante"
                 v-validate
                 data-vv-as="nome"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('nomeSolicitante')">{{ errors.first('nomeSolicitante') }}</p>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="form-group" :class="{'has-error': errors.has('emailSolicitante')}">
          <label class="control-label" for="email-solicitante">E-mail</label>

          <input type="text"
                 class="form-control"
                 id="email-solicitante"
                 data-vv-name="emailSolicitante"
                 v-model="solicitacao.emailSolicitante"
                 v-validate
                 data-vv-as="e-mail"
                 maxlength="300">

          <p class="text-danger" v-show="errors.has('emailSolicitante')">{{ errors.first('emailSolicitante') }}</p>
        </div>
      </div>
      <div class="col-sm-2">
        <div class="form-group" :class="{'has-error': errors.has('telefoneSolicitante')}">
          <label class="control-label" for="telefone-solicitante">Telefone</label>

          <input type="text"
                 class="form-control"
                 id="telefone-solicitante"
                 data-vv-name="telefoneSolicitante"
                 v-model="solicitacao.telefoneSolicitante"
                 v-validate
                 data-vv-as="telefone"
                 v-mascara="'telefone'">

          <p class="text-danger" v-show="errors.has('telefoneSolicitante')">{{ errors.first('telefoneSolicitante') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-curso-evento-servico/componentes/compartilhado/FormDadosSolicitacao.vue